import CoreBase from './CoreBase';
import { subscribe } from '../utils/pubsub';
import { events } from '../wss/SystemEvents';

export default class EngineCleanupBase extends CoreBase {
    _name = 'EngineCleanupBase';
    _onCleanup = null;

    /**
     * Subscribes to onClearCache event.
     * Calls this.clear() when fired — subclass can override clear() for custom cleanup.
     */
    initialize(name) {
        this._name = name;
        this._onCleanup = subscribe(events.onClearCache, () => this.clear());
    }

    /**
     * Releases the onClearCache subscription.
     * Subclasses must call super.clear() for proper cleanup.
     * Prototype method — required for super.clear() to work from subclass arrow functions.
     */
    clear() {
        try {
            if (this._onCleanup) this._onCleanup = this._onCleanup();
        } catch (error) {
            this.logError('clear', error.message);
        }
    }
}
